import { useTranslation } from 'react-i18next';
import { cn } from '../../../lib/utils';

interface EquipmentTypeFilterProps {
    types: string[];
    value: string | null;
    onChange: (type: string | null) => void;
}

export default function EquipmentTypeFilter({
    types,
    value,
    onChange,
}: EquipmentTypeFilterProps) {
    const { t } = useTranslation();
    const counts = types.reduce<Record<string, number>>((acc, type) => {
        acc[type] = (acc[type] ?? 0) + 1;
        return acc;
    }, {});

    if (types.length === 0) return null;

    return (
        <div className="flex flex-wrap gap-1.5">
            {[null, ...Object.keys(counts).sort()].map((type) => (
                <button
                    key={type ?? 'all'}
                    type="button"
                    onClick={() => onChange(type)}
                    className={cn(
                        'rounded-full px-2.5 py-1 text-xs font-medium transition-colors',
                        value === type
                            ? 'bg-foreground text-background'
                            : 'bg-muted text-subtle-foreground hover:text-foreground dark:bg-neutral-800'
                    )}
                >
                    {type ?? t('roomOverview.equipment.filterAll')}
                    <span className="ml-1.5 tabular-nums">
                        {type ? counts[type] : types.length}
                    </span>
                </button>
            ))}
        </div>
    );
}
